import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	itemKnowledgeBase: {
		id: 'spa-apps-sidebar-servicedesk.common.knowledge-item.item-knowledge-base',
		defaultMessage: 'Knowledge base',
		description: 'Navigation item which opens knowledge base modal',
	},
	itemKnowledgeBaseHub: {
		id: 'spa-apps-sidebar-servicedesk.common.knowledge-item.item-knowledge-base-hub',
		defaultMessage: 'Knowledge base',
		description: 'Navigation item which opens knowledge base hub',
	},
	allArticles: {
		id: 'spa-apps-sidebar-servicedesk.common.knowledge-item.all-articles',
		defaultMessage: 'Articles',
		description: 'JSM Knowledge Hub - item in navigation which redirects to all categories',
	},
	drafts: {
		id: 'spa-apps-sidebar-servicedesk.common.knowledge-item.drafts',
		defaultMessage: 'Drafts',
		description: 'JSM Knowledge Hub - item in navigation which redirects to drafts',
	},
	heading: {
		id: 'spa-apps-sidebar-servicedesk.common.knowledge-item.heading',
		defaultMessage: 'Knowledge base',
		description: 'JSM Knowledge Hub - heading for section "Knowledge base"',
	},
	categories: {
		id: 'spa-apps-sidebar-servicedesk.common.knowledge-item.categories',
		defaultMessage: 'Categories',
		description:
			'JSM Knowledge Hub - heading for the group where we list all available categories.',
	},
	newCategory: {
		id: 'spa-apps-sidebar-servicedesk.common.knowledge-item.new-category',
		defaultMessage: 'New category',
		description:
			'JSM Knowledge Hub - item in navigation which opens modal which allows to create new category',
	},
	suggestedTopics: {
		id: 'spa-apps-sidebar-servicedesk.common.knowledge-item.suggested-topics',
		defaultMessage: 'Suggested topics',
		description: 'JSM Knowledge Hub - item in navigation which redirects to suggested topics',
	},
});
